<div class="sg-full-size sg-cookie-policy-page sg-flex-column sg-justify-start sg-items-center">
  <img class="sg-page-logo" [src]="logoSrc" />
  <sg-text variant="sg-h2-standard" class="page-title">Cookies for Analytics tools</sg-text>
  <div class="content-wrapper">
    <div class="sg-full-height sg-cookie-policy-container">
      <div class="main-item">
        <sg-text variant="sg-p3-strong">
          We use a limited number of usage analytics cookies to improve your user experience and the functionality of our products. This is done by tracking
          user behaviour when accessing the interface to compile statistical reports. As a customer, you can control the preferences of the cookies and decide
          which, if any, we may use. However, in a few cases, some interface features may not function as a result of turning the cookies off.
        </sg-text>
      </div>
      <div class="main-item">
        <sg-text variant="sg-h4" class="section-title">How Cookies Work</sg-text>
        <sg-text variant="sg-p3-standard">
          Cookies are small text files which are placed on your browser. A cookie doesn’t give us access to your computer or any information about you, other
          than the information you choose to share with us. We may use this information to understand the effectiveness of our products and improve your
          experience in the future.
        </sg-text>
      </div>
      <div class="main-item">
        <sg-text variant="sg-h4" class="section-title">The Types of Cookies We Use</sg-text>
        <sg-text variant="sg-p3-standard">
          Analytical / performance cookies are the only cookies we currently use. They allow us to recognise and count the number of visitors and to see how
          they interact with our product interface. Heat Mapping and Visitor Recording services are used to display the areas of a page where our users most
          frequently move the mouse or click. By showing us where the points of interest are, these cookies enable us to monitor and analyse traffic and user
          behaviour. This further helps us improve your experience when using our digital products and the functionality of our platform.
        </sg-text>
      </div>
      <sg-text variant="sg-h4" class="section-title">Analytics tools we use</sg-text>
      <div class="sub-item">
        <sg-text variant="sg-p3-strong">Hotjar</sg-text>
        <sg-text variant="sg-p3-standard">
          We use Hotjar in order to better understand our users’ needs and to optimise the functionality and user experience we provide on out platform. Hotjar
          is a technology service that helps us better understand our users’ experience (e.g. how much time they spend on which screens, which links they choose
          to click, whether users understand how to use the new interface features we release, and more...). Hotjar uses cookies and other technologies to
          collect data on our users’ behaviour and their devices. This includes a device's IP address (processed during your session and stored in a
          de-identified form), device screen size, device type (unique device identifiers), browser information, geographic location (country only), and the
          preferred language used to display our interface. Hotjar stores this information on our behalf in a pseudonymized user profile. Hotjar is
          contractually forbidden to sell any of the data collected on our behalf.
        </sg-text>
        <a class="sg-link" target="_blank" href="https://www.hotjar.com/legal/policies/privacy/">Hotjar privacy policy</a>
      </div>
      <div class="sub-item">
        <sg-text variant="sg-p3-strong">Heap</sg-text>
        <sg-text variant="sg-p3-standard">
          Heap is a user behavioural analytics service. We use Heap to collect and analyse data about how our users are interacting with our interface. Heap
          collects data on what users are doing, including but not limited to which URLs they visit within our products, what they click on, where they are
          located, what browser or platform they are using, and other forms of behavioral data.
        </sg-text>
        <a class="sg-link" target="_blank" href="https://heap.io/privacy">Heap privacy policy</a>
      </div>
      <div class="sub-item">
        <sg-text variant="sg-p3-strong">Pendo</sg-text>
        <sg-text variant="sg-p3-standard">
          Pendo is a product analytics and business intelligence service. We use Pendo to collect and analyse data in order to understand users and user
          behavior in order to improve our services. Pendo collects data on user attributes, page views and user interactions with our interface.
        </sg-text>
        <a class="sg-link" target="_blank" href="https://www.pendo.io/legal/privacy-policy/">Pendo privacy policy</a>
      </div>
      <sg-text variant="sg-h4" class="section-title">CGS intellectual property rights</sg-text>
      <div class="main-item">
        <sg-text variant="sg-p3-standard">
          You agree, acknowledge, and represent to us that: (i) your provision to us, of any and all CUSIP standard numbers, CUSIP standard descriptions, CGS
          ISINs and/or CINS numbers a (together, the “CGS numbers”), and the use by us of any such CGS numbers, are based on lawful and valid licensing,
          distribution, and/or sub-distribution rights obtained by you, and/or do not infringe upon any intellectual rights owned by, or licensed to, any third
          party, including but not limited to CUSIP Global Services and the American Bankers Association; and (ii) you shall fully indemnify and hold harmless
          Sharegain and any of its directors, officers, employees, agents, contractors and representative against any third-party alleging such infringement,
          including without limitation, as regards any legal fees.
        </sg-text>
      </div>
    </div>
  </div>
</div>
